import Enterprises from '../../../components/customer/enterprises/Enterprises'

const CustomerEnterprises = () => {
    return <Enterprises />
}

export default CustomerEnterprises
